import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { Checkbox, KeyPads, Modal, TextField } from "components"
import OfflineOrderDetailCancelModalHeader from "./OfflineOrderDetailCancelModalHeader"
import OfflineOrderDetailCancelModalFooter from "./OfflineOrderDetailCancelModalFooter"
import classes from "./index.module.scss"

const initialFormState = {
  amount: 0,
  cancelReasons: "",
  refundType: "cash"
}

const initialFormErrorsState = {
  amount: "",
  cancelReasons: ""
}

const OfflineOrderDetailCancelModal = props => {
  const {
    offlineOrder,
    setOfflineOrder,
    showConfirmationModal,
    setShowConfirmationModal
  } = props

  const [t, i18n] = useTranslation()

  const [form, setForm] = useState(initialFormState)
  const [formErrors, setFormErrors] = useState(initialFormErrorsState)
  const [disableKeyboard, setDisableKeyboard] = useState(false)

  const handleChange = (value, name) => {
    setForm(prev => ({ ...prev, [name]: value }))
  }

  const handleExited = () => {
    setForm({ ...initialFormState })

    setFormErrors({ ...initialFormErrorsState })
  }

  const canRefundToUserWallet =
    !!offlineOrder.accountId &&
    offlineOrder.orderStatus === "paid" &&
    offlineOrder.accountRole === "user"

  const total = offlineOrder.total

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <Modal
      show={showConfirmationModal}
      onExited={handleExited}
    >
      <div className={classes["container"]}>
        <OfflineOrderDetailCancelModalHeader
          total={total}
          amount={form.amount}
          orderStatus={offlineOrder.orderStatus}
        />

        {
          offlineOrder.orderStatus === "paid" &&
          <div
            className={clsx(
              classes["keypads"],
              isLtr && classes["keypads-ltr"]
            )}
          >
            <KeyPads
              value={form.amount}
              disableKeyboard={disableKeyboard}
              onChange={text => handleChange(text, "amount")}
            />
          </div>
        }

        {
          canRefundToUserWallet &&
          <div className={classes["row"]}>
            <div className={classes["refund"]}>
              <Checkbox
                onChange={() => handleChange("cash", "refundType")}
                checked={form.refundType === "cash"}
              />
              <span
                className={clsx(
                  classes["refund-text"],
                  isLtr && classes["refund-text-ltr"]
                )}
              >
                {t("بازپرداخت_به_صورت_نقدی")}
              </span>
            </div>

            <div className={classes["refund"]}>
              <Checkbox
                onChange={() => handleChange("wallet", "refundType")}
                checked={form.refundType === "wallet"}
              />
              <span className={classes["refund-text"]}>
                {t("بازپرداخت_به_کیف_پول_کاربر")}
              </span>
            </div>
          </div>
        }

        <TextField
          componentClass="textarea"
          rows={3}
          type="text"
          label={t("دلیل_لغو_سفارش")}
          value={form.cancelReasons}
          error={formErrors.cancelReasons}
          className={classes["input"]}
          onFocus={() => setDisableKeyboard(true)}
          onBlur={() => setDisableKeyboard(false)}
          onChange={(e) => handleChange(e.target.value, "cancelReasons")}
        />

        <OfflineOrderDetailCancelModalFooter
          form={form}
          total={total}
          offlineOrder={offlineOrder}
          setOfflineOrder={setOfflineOrder}
          setFormErrors={setFormErrors}
          setShowConfirmationModal={setShowConfirmationModal}
          initialFormErrorsState={initialFormErrorsState}
        />
      </div>
    </Modal>
  )
}

export default OfflineOrderDetailCancelModal